import axios from './axios';

export const cartService = {
  fetchCart: async () => {
    try {
      const response = await axios.get('/cart');
      return response;
    } catch (error) {
      return error.response;
    }
  },

  addToCart: async (data) => {
    try {
      const response = await axios.post('/cart', data);
      // console.log("resp",response.data)
      return response;
    } catch (error) {
      return error.response;
    }
  },

  updateCartItem: async (data) => {
    try {
      const response = await axios.put('/cart', data);
      // console.log("resp",response.data)

      return response;
    } catch (error) {
      return error.response;
    }
  },

  removeFromCart: async (itemId) => {
    try {
      const response = await axios.delete(`/cart/${itemId}`);
      return response;
    } catch (error) {
      return error.response;
    }
  },

  clearCart: async () => {
    try {
      const response = await axios.delete('/cart/clear');
      return response;
    } catch (error) {
      return error.response;
    }
  },

  checkout: async (body) => {
    try {
      // console.log("body",body)
      const response = await axios.post('/cart/checkout',body);
      return response;
    } catch (error) {
      return error.response;
    }
  }
};